import { z } from 'zod';
import { LicenseTypes } from '../../types/licenses';
import {
  BasicBusinessInformationSchema,
  type BusinessInformation,
} from '../business-information/forms/types/businessInformation';

export const THEATER_CONTENT_PATH = 'licenses.steps.initialInformation.theater';

// Strict time validation (HH:MM with 00-23 hours and 00-59 minutes)
const timeFormat = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

export const theaterInitialInformationSchema = BasicBusinessInformationSchema.extend({
  theaterName: z.string().min(1, {
    message: `${THEATER_CONTENT_PATH}.showInfoSection.theaterName.validation.required`,
  }),
  performanceTitle: z.string().min(1, {
    message: `${THEATER_CONTENT_PATH}.showInfoSection.performanceTitle.validation.required`,
  }),
  performanceDuration: z
    .string()
    .min(1, {
      message: `${THEATER_CONTENT_PATH}.showInfoSection.performanceDuration.validation.required`,
    })
    .refine(v => timeFormat.test(v), {
      message: `${THEATER_CONTENT_PATH}.showInfoSection.performanceDuration.validation.format`,
    }),
  totalShowings: z
    .number({
      required_error: `${THEATER_CONTENT_PATH}.showInfoSection.totalShowings.validation.required`,
    })
    .int({ message: `${THEATER_CONTENT_PATH}.showInfoSection.totalShowings.validation.required` })
    .min(1, { message: `${THEATER_CONTENT_PATH}.showInfoSection.totalShowings.validation.required` }),
  performanceDateOrPeriod: z.string().min(1, {
    message: `${THEATER_CONTENT_PATH}.showInfoSection.performanceDateOrPeriod.validation.required`,
  }),
  totalAudience: z
    .number({
      required_error: `${THEATER_CONTENT_PATH}.showInfoSection.totalAudience.validation.required`,
    })
    .int({ message: `${THEATER_CONTENT_PATH}.showInfoSection.totalAudience.validation.required` })
    .min(1, { message: `${THEATER_CONTENT_PATH}.showInfoSection.totalAudience.validation.required` }),
  totalTicketRevenue: z
    .number({
      required_error: `${THEATER_CONTENT_PATH}.showInfoSection.totalTicketRevenue.validation.required`,
    })
    .min(1, { message: `${THEATER_CONTENT_PATH}.showInfoSection.totalTicketRevenue.validation.required` }),
});

export const createTheaterInitialInformationDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.Theater,
  theaterName: '',
  performanceTitle: '',
  performanceDuration: '',
  performanceDateOrPeriod: '',
});

export type TheaterInitialInformation = z.infer<typeof theaterInitialInformationSchema>;
